import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import classes from './ResultModal.module.css';
import { Button } from 'lb-components';
import { DividerIcon } from '../../../assets/icons/modal';
import { useTranslation } from 'lb-store';
import cs  from "classnames"
import {UseUser} from "lb-store/src/hooks";
export const ResultModal = ({
  onCancel,
  onSuccess,
  onReject,
  actionLabel,
  cancelLabel,
  message,
  header,
  backdropDismiss,
  containerStyle,
  footerComponent=(cancel)=>null,
   bodyComponent=(cancel)=>null,
  footer=true,
  ...props
}) => {
  const { t } = useTranslation();
  const [state,setState] = React.useState(null)
  const {logout} = UseUser();

  return (
    <Modal
      contentClassName={cs(classes.container,containerStyle)}
      onHide={onCancel}
      onTouchStart={(e) => e.stopPropagation()}
      backdrop={backdropDismiss ? 'static' : true}
      dialogClassName={cs(classes.wrapper, classes[containerStyle])}
      {...props}
    >
      <Modal.Header
        closeButton
        closeVariant={'white'}
        className={classes.header}
      >{header}</Modal.Header>
      <Modal.Body className={classes.body}>{message}</Modal.Body>
      {
       bodyComponent({cancel:onCancel,setState,state,t,exit:()=>logout()})
      }
      {
        footer && (
          <Modal.Footer
            className={classes.footer}
            style={{ '--divider': `url(${DividerIcon})` }}
          >
            {onSuccess && (
              <Button
                variant={'success'}
                onClick={() => onSuccess({ cancel: onCancel })}
              >
                {t(actionLabel)}
              </Button>
            )}
            {onReject ?(
                <Button
                    variant={'secondary'}
                    onClick={() => onReject({ cancel: onCancel })}
                >
                  {t(cancelLabel)}
                </Button>
            ):(
                <Button variant={'secondary'} onClick={onCancel}>
                  {t(cancelLabel)}
                </Button>
            )}




          </Modal.Footer>
        )
      }
      {footerComponent({cancel:onCancel})}
    </Modal>
  );
};

ResultModal.propTypes = {
  show: PropTypes.bool,
  centered: PropTypes.bool,
  message: PropTypes.any,
  header: PropTypes.any,
};
ResultModal.defaultProps = {
  show: true,
  centered: true,
  message: 'არასწორი პარამეტრები',
  header: '',
};
